import script from "./AIChatHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./AIChatHeader.vue?vue&type=script&lang=ts&setup=true"

import "./AIChatHeader.vue?vue&type=style&index=0&id=c3c02aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3c02aa8"]])

export default __exports__